// extracted by mini-css-extract-plugin
export var completeIcon = "VOa8I";
export var flagButtonColor = "DEQdJ";
export var flagButtonFilledColor = "zSlUZ";
export var flagFilledColor = "a7Z3n";
export var flagIconColor = "admf7";